var lists_default = {
  "fontElementMap": "gpMuU",
  "orderedlist": "xH5Yt",
  "bulletedlist": "AWHZw",
  "listItem": "-fEAs"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
